function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.543C1 2.415 1.884 1.5 2.974 1.5h10.052c1.09 0 1.974.915 1.974 2.043 0 .935-.607 1.723-1.436 1.966v6.948c0 1.128-.884 2.043-1.974 2.043H4.41c-1.09 0-1.974-.915-1.974-2.043V5.51C1.607 5.266 1 4.478 1 3.543zm2.513 2.043v6.871c0 .513.402.929.897.929h7.18c.495 0 .897-.416.897-.929V5.586H3.513zm-.539-2.972c-.495 0-.897.416-.897.929 0 .513.402.928.897.928h10.052c.495 0 .897-.415.897-.928 0-.513-.402-.929-.897-.929H2.974z",
  fill: "#2D2D2D"
});
function SvgCaja(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Caja.svg";
export { SvgCaja as ReactComponent };